export default __webpack_public_path__ + "static/media/submit-service-ar.2a0dd775.png";